import { render, staticRenderFns } from "./chainDetails.vue?vue&type=template&id=ea362b34&scoped=true&"
import script from "./chainDetails.vue?vue&type=script&lang=js&"
export * from "./chainDetails.vue?vue&type=script&lang=js&"
import style0 from "./chainDetails.vue?vue&type=style&index=0&id=ea362b34&scoped=true&lang=css&"
import style1 from "./chainDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea362b34",
  null
  
)

export default component.exports